// @ts-expect-error - DateTransform is not typed
import { DateTransform } from "@ember-data/serializer/transform";
import dayjs from "dayjs";
import ControlTower from "wise-control-tower";

export default class DateWithOffsetTransform extends DateTransform {
  deserialize(serialized: string, options: unknown) {
    return super.deserialize(serialized, options);
  }

  serialize(date: Date, _options: unknown) {
    if (date instanceof Date) {
      return dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ");
    }

    ControlTower.captureMessage(
      `DateWithOffsetTransform: ${date} is not a Date`
    );
    return null;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "date-with-offset": DateWithOffsetTransform;
  }
}
